import defineMessages from "../../../common/helpers/defineMessages";

const messages = defineMessages({
    title: {
        id: "error.404.title",
    },
});

export default messages;
